<template>
  <div class="public-brand-header">
    <img :src="erriffHealthLogo" alt="Erriff Health" class="public-brand-header__logo" />
  </div>
</template>

<script>
import erriffHealthLogo from "@/assets/images/erriff-health-logo.svg";

export default {
  name: "PublicBrandHeader",
  data() {
    return { erriffHealthLogo };
  },
};
</script>

<style scoped lang="scss">
.public-brand-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.25rem;
}

.public-brand-header__logo {
  width: 100px;
  height: auto;
}
</style>
